import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>As a manager it’s a good skill to be able to focus on the
                                                bigger picture; to take a more strategic
                                                view and not get preoccupied with details. Managers often
                                                need to maintain focus on the wider
                                                business objectives rather than the details of a task. This
                                                tool is about<span className="green brownbold"> how to focus on the
bigger picture</span> and provides you with some insight into how to raise yourself from the
                                                detail in order to focus on the overall context. This should
                                                help you to be more strategic, contextual
                                                and visionary.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
FOCUSING ON THE BIGGER PICTURE
</span></div>
                                            <p>Focusing on the bigger picture in the workplace is becoming
                                                an increasingly valued skill. It is
                                                important to focus on the bigger picture to ensure that
                                                ideas that are implemented actually tie in
                                                with the achievement of your overall objectives. It is easy
                                                to get bogged down with the detail and
                                                lose sight of what you are actually trying to achieve. </p>
                                            <p>Many people find that their thinking patterns will naturally
                                                tend to focus on ‘how’ without always
                                                considering ‘why’ and ‘what’. This focus on processes rather
                                                than strategy is sometimes a
                                                consequence of the reward system of the organisation. Reward
                                                systems tend to be based on
                                                processes with less regard for the overall strategy of the
                                                organisation. Strategic planning and
                                                thinking are necessary at both an organisational and
                                                individual level in order to capture the
                                                bigger picture.</p>

                                            <p>Strategic thinking involves ascertaining what it is that
                                                decides the direction, nature and focus of
                                                the business. Strategic planning focuses on how to get
                                                there.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading lightbgcenter">
                                                <p><span className="subtiltereg">Always ask ‘WHY’ before ‘HOW’</span>
                                                </p>
                                            </div>
                                            <p>The purpose of asking ‘WHY?’ before ‘HOW?’ is to understand
                                                the way in which your task fits in
                                                with the overall strategy of the organisation. It is vital
                                                to question your actions in this way to
                                                ensure that you are not wasting your efforts on tasks that
                                                are not aligned with either your own
                                                goals or the organisation’s goals. It is very easy to work
                                                hard at something only to find that you
                                                are working towards the wrong goal!</p>
                                            <p>In terms of organisational goals it should be quite easy to
                                                understand what these are by talking
                                                to others in your organisation. If you are focusing on
                                                individual goals it can be slightly more
                                                complicated. However, there are several techniques you can
                                                use. Some examples follow:</p>
                                            <div className="border_subtitle">Visualisation</div>
                                            <p>Visualise your ideal self in the future, e.g. Where are you?
                                                What are you doing? What have you
                                                achieved? This helps to develop a memory trace and
                                                understand how you might achieve the
                                                goals. This skill takes practice and perseverance, yet many
                                                hugely successful individuals swear
                                                by it – so it is worth a try.</p>
                                            <div className="border_subtitle">Systems thinking</div>
                                            <p>Research indicates that a different technique to help us
                                                focus on the bigger picture involves
                                                becoming familiar with ‘Systems thinking’. This is a
                                                framework based on the belief that the only
                                                way to fully understand why a problem occurs and persists is
                                                to understand the individual part in
                                                relation to the whole system. The idea is that component
                                                parts of a system are interdependent on
                                                the rest of it. If you attempt to isolate a component, then
                                                it will behave differently from when it
                                                was part of the larger system.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}